<template>
  <el-empty description="V-IM"></el-empty>
  22
</template>

<script setup lang="ts"></script>

<style scoped></style>
